
import {Component, Prop, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import PazToast from '@pazion/pazion-core/src/components/utils/PazToast.vue';
import {authentication} from "@pazion/pazion-core/src/store";
import PazTooltipButton from '@pazion/pazion-core/src/components/controls/PazTooltipButton.vue';
import {IRequiredDocument} from "@pazion/pazion-core/src/models/dossier.model";
import {uploadDossierFile} from "@pazion/pazion-core/src/services/dossier-service";

@Component({
  components: {
    PazToast,
    PazTooltipButton
  }
})
export default class DossierRequiredDocument extends Vue {

  $refs!: {
    toast: PazToast
  };
  fileRules = [
    value => {
      if (!value || !value.length) {
        return true;
      }
      for (let v of value) {
        if (v.size > 16000000)
          return 'Bestanden moeten kleiner zijn dan 16 mb';
      }
      return true;
    },
  ];
  @Prop()
  public requiredDocument!: IRequiredDocument;

  @Prop()
  public dossierId!: number;

  public loading: boolean = false;
  public uploadSuccess: boolean = false;
  public notApplicable: boolean = false;

  public hasFile: boolean = false;

  public description: string = '';
  public uploadedFiles: {id: number,filename:string }[] = [];

  public files: File[] = [];
  // @VModel()
  // public dossier!: object;

  get isAdmin(){
    return authentication.isAdmin;
  }
  get presentFiles(){
    return this.requiredDocument.uploadedFiles.concat(this.uploadedFiles);
  }
  async uploadFile() {
    this.loading = true;
    for (let file of this.files) {
      if (file.size > 16000000) {
        this.$refs.toast.show({message: 'Bestand [' + file.name + '] te groot!'});
        this.loading = false;
        return;
      }
    }
    let rsp= null;
    for (let file of this.files) {
      rsp = await uploadDossierFile(this.dossierId,
          file, this.description, undefined, undefined, undefined, this.requiredDocument.id);
    }

    if (rsp.success) {
      this.$refs.toast.show({message: 'Bestand(en) succesvol geüpload!'});
      this.$emit('uploadSuccess');
      this.uploadedFiles.push({filename: rsp.clientname, id: rsp.id});

      if (this.requiredDocument.id > 0) {
        if(!this.requiredDocument.fileExists){
          this.$emit('bumpFileCount');
        }
        this.uploadSuccess = rsp.success;
        this.requiredDocument.fileExists = true;
      }
      this.files = [];
    }
    this.loading = false;
  }
  handleFile(file: File){

  }

  mounted() {
    this.notApplicable = this.requiredDocument.isPresent && !this.requiredDocument.fileExists;
    // console.log(this.notApplicable);
  }

  @Watch('notApplicable')
  public notApplicableChanged(newValue: boolean, oldValue: boolean) {
    // console.log(this.files);
    // console.log(newValue);
    uploadDossierFile(this.dossierId, [], this.requiredDocument.id, this.description).then((rsp) => {

      // console.log(rsp);
    });
  }

  get canUpload() {
    if (this.files instanceof File) {
      return this.files.size < 16000000;
    }
    if (this.files.length) {
      for (let file of this.files) {
        if (file.size > 16000000) {
          return false;
        }
      }
      return true;
    }
    return false;
  }
  get showUploadForm(){
    if(this.requiredDocument.isAdminOnly){
      return this.isAdmin;
    }
    return true;
  }
  get showSuccesAlert() {
    return this.requiredDocument.fileExists || this.isuploadSuccess || this.notApplicable;
  }

  get isuploadSuccess() {
    return this.uploadSuccess;
  }
  async downloadFile(arg: {id: number,filename:string }) {
    let fileRequest = await downloadDossierFile(arg.id);
    console.log(arg);
    const fileURL = window.URL.createObjectURL(b64toBlob(fileRequest.content, fileRequest.extension));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileRequest.fileName);
    document.body.appendChild(fileLink);

    fileLink.click();

  }

}
